module.exports = __webpack_public_path__ + "static/media/pricing-rules.89348866.png";